import { render, staticRenderFns } from "./ModalThemTinhThanhVaoVung.vue?vue&type=template&id=1548a454&"
import script from "./ModalThemTinhThanhVaoVung.vue?vue&type=script&lang=js&"
export * from "./ModalThemTinhThanhVaoVung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports